import { ECOMMERCE_DEVELOPMENT_ROOT } from '@cat-ecom/pcc-components/src/components/common/constants';
/**
 * Checks if the environment is in development mode
 */
export const isDev = () => process.env['NODE_ENV'] === 'development';

/**
 * capitalize a string.
 * @param str
 * @returns
 */
export const capitalizeText = (str = '') => {
  return str
    ?.toLowerCase()
    ?.replace(/(\b[a-z](?!\s))/g, (letter) => letter?.toUpperCase());
};

export const normalizeCommerceLink = (link: string) =>
  isDev() && !link?.startsWith(ECOMMERCE_DEVELOPMENT_ROOT)
    ? `${ECOMMERCE_DEVELOPMENT_ROOT}${link}`
    : link;

export const isLangEsiteExist = (url: string) => {
  const [, lang, esite] = url?.split('/') ?? [];
  return Boolean(lang && esite) || url.includes('https');
};
export const isValidSerialNumber = (inputSn = '') => {
  if (inputSn?.length !== 8) return false;
  const firstThree = inputSn.slice(0, 3);
  const lastFive = inputSn.slice(3);
  const alphaNumPattern = /^[A-Za-z0-9]{3}$/;
  const mustContainAlphabetPattern = /[A-Za-z]/;
  const numericPattern = /^\d{5}$/;

  return (
    alphaNumPattern.test(firstThree) &&
    mustContainAlphabetPattern.test(firstThree) &&
    numericPattern.test(lastFive)
  );
};
